/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PagingMode {
    Precise = '0',
    LightWeight = 1,
    Cursor = 2,
    FullPage = 3,
    Count = 4,
}
